<template>
  <div class="family">

    <Head :index="'2'"></Head>

    <div class="chartTop"></div>
    <!-- tableData -->
    <div class="listDiv">
      <ul>
        <li v-for="(item, index) in tableData" :key="index">
          <div style="border: 0px;font-size: 25px;line-height:28px;text-align: center;margin-bottom: 20px">
            {{ item.name + "定位表" }}
          </div>
          <div>
            <table class="tableT" border>
              <tr>
                <td class="label"><span style="color:red">*</span> 家族姓氏</td>
                <td><span>{{ item.familyname }}</span></td>
                <td class="label"><span style="color:red">*</span> 民族</td>
                <td><span>{{ item.mz }}</span></td>
              </tr>
              <tr v-if="item.shang == 1">
                <td>&nbsp;</td>
                <td>本&nbsp;&nbsp;谱</td>
                <td colspan="2">上&nbsp;&nbsp;源&nbsp;&nbsp;谱</td>
              </tr>
              <tr>
                <td class="label">堂&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
                <td colspan="3" v-if="item.shang == 0"><span>{{ item.tangnum }}</span></td>
                <td style="width: 360px;" v-if="item.shang == 1"><span>{{ item.tangnum }}</span></td>
                <td colspan="2" v-if="item.shang == 1"><span>{{ item.sytangnum }}</span></td>
              </tr>
              <tr>
                <td class="label"><span style="color:red">*</span> 始祖名讳</td>
                <td colspan="3" v-if="item.shang == 0"><span>{{ item.ancestorname }}</span></td>
                <td v-if="item.shang == 1"><span>{{ item.ancestorname }}</span></td>
                <td colspan="2" v-if="item.shang == 1"><span>{{ item.syancestorname }}</span></td>
              </tr>
              <tr>
                <td class="label"><span style="color:red">*</span> 世&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系</td>
                <td colspan="3" v-if="item.shang == 0"><span>{{ item.familytree }}世</span></td>
                <td v-if="item.shang == 1"><span>{{ item.familytree }}世 （上源谱{{ item.beforefamilytree }}世）</span></td>
                <td colspan="2" v-if="item.shang == 1"><span>{{ item.syfamilytree }}世</span></td>
              </tr>
              <tr>
                <td class="label"><span style="color:red">*</span> 发&nbsp;源&nbsp;地</td>
                <td colspan="3" v-if="item.shang == 0"><span>{{ item.fyzdydz }}</span></td>
                <td v-if="item.shang == 1"><span>{{ item.fyzdydz }}</span></td>
                <td colspan="2" v-if="item.shang == 1"><span>{{ item.syfyzdydz }}</span></td>
              </tr>
              <tr>
                <td class="label"><span style="color:red">*</span> 起始年代</td>
                <td colspan="3" v-if="item.shang == 0"><span>{{ item.fromyear }}</span></td>
                <td v-if="item.shang == 1"><span>{{ item.fromyear }}</span></td>
                <td colspan="2" v-if="item.shang == 1"><span>{{ item.syfromyear }}</span></td>
              </tr>
              <tr>
                <td class="label">家族简介</td>
                <td colspan="3">
                  <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 100 }" v-model="item.intro" readonly=""
                            style="font-size: 16px; color: #000"></el-input>
                </td>
              </tr>
              <tr>
                <td class="label">操作</td>
                <td colspan="3">
                  <el-button @click="viewClick(item)" size="small" v-if="item.id != familyId"
                             style="background-color:#DAA520;color: #fff">使用本家谱
                  </el-button>
                  <el-button @click="editClick(item)" type="primary" size="small" v-if="item.canEdit">编辑</el-button>
                  <el-button @click="delClick(item)" type="danger" size="small" v-if="item.canDel">删除</el-button>
                  <el-button @click="candelClick(item.id)" size="small" v-if="item.canDel">权限设置</el-button>
                </td>
              </tr>
            </table>
          </div>
        </li>
        <li style="border:0px;text-align: right">
          <span>还可建立若干个分支（居住地）家谱定位表</span>
          <el-button type="primary" style="margin:10px" @click="addClick()">添加</el-button>
        </li>
      </ul>
    </div>
    <!--        <div style="width: 1300px;margin:0 auto">-->
    <!--            <el-button type="primary" style="margin:10px" @click="addClick()">添加</el-button>-->
    <!--            <span>您可以建立一个小家谱定位表，限9代</span>-->
    <!--        </div>-->

    <el-dialog :visible.sync="dialogFamily" width="1000px">
      <span>
        <el-form :model="ruleForm" :rules="addRules" status-icon ref="ruleAddForm" label-width="120px" label-position="left"
                 class="demo-ruleForm">
          <el-form-item label="谱名" prop="name" style="margin-bottom: 20px;">
            <el-input type="text" v-model="ruleForm.name" placeholder="请输入谱名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="家族姓氏" prop="familyname" style="margin-bottom: 20px;">
            <el-input type="text" v-model="ruleForm.familyname" placeholder="最大姓氏九个汉字"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="堂号" prop="tangnum" style="margin-bottom: 20px;">
            <el-input type="text" v-model="ruleForm.tangnum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="民族" prop="mz" style="margin-bottom: 20px;">
            <el-select v-model="ruleForm.mz" placeholder="请选择民族" style="width:120px">
              <el-option value="">请选择</el-option>
              <el-option :value="item" v-for="item in $store.state.mzData" :key="item.index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="始祖名讳" prop="ancestorname" style="margin-bottom: 20px;">
            <el-input type="text" v-model="ruleForm.ancestorname" autocomplete="off"
                      placeholder="请填写全名"></el-input>
          </el-form-item>
          <el-form-item label="本谱世系" prop="familytree" style="margin-bottom: 20px;">
            <el-input type="number" v-model.number="ruleForm.familytree" autocomplete="off" style="width:100px" :min="0"
                      :step="1"></el-input>&nbsp;&nbsp;世
          </el-form-item>
          <el-form-item label="单双世系选择">
            <el-radio-group v-model="ruleForm.shang">
              <el-radio :label="0">本谱单一世系显示&nbsp;<span style="color:red">(默认)</span></el-radio>
              <el-radio :label="1">有上源谱，双世系显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上源谱世系" prop="beforefamilytree" style="margin-bottom: 20px;" v-if="ruleForm.shang == 1">
            <el-input type="number" v-model.number="ruleForm.beforefamilytree" autocomplete="off" style="width:100px"
                      :min="0" :step="1"></el-input>&nbsp;&nbsp;世
          </el-form-item>
          <el-form-item label="发源地" prop="befrom" style="margin-bottom: 20px;">
            <!-- <el-input type="text" v-model="ruleForm.befrom" autocomplete="off"></el-input> -->
            <Area :propsinorout="ruleForm.fyinorout || 1" :propssheng="ruleForm.fysheng" :propsshi="ruleForm.fyshi"
                  :propsxian="ruleForm.fyxian" :propszhen="ruleForm.fyzhen" :propsdizhi="ruleForm.fyzdydz"
                  @area="areaFun"></Area>
          </el-form-item>
          <el-form-item label="起始年代" prop="fromyear" style="margin-bottom: 20px;">
            <el-input type="text" v-model="ruleForm.fromyear" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="祖源地" prop="befrom">
                      <el-input @focus="mapOpen('coordinate')" v-model="ruleForm.coordinate"></el-input>
                  </el-form-item>
                  <el-form-item label="上游谱中世系" prop="beforefamilytree">
                      <el-input type="text" v-model="ruleForm.beforefamilytree" autocomplete="off"></el-input>
                  </el-form-item> -->
          <el-form-item label="家族简介" prop="intro" style="margin-bottom: 20px;">
            <el-input type="textarea" :rows="10" v-model="ruleForm.intro"></el-input>
          </el-form-item>
          <div v-if="ruleForm.shang == 1">
            <div style="text-align: center; margin-bottom: 20px;font-size: 20px;">上  源  谱</div>
            <el-form-item label="堂号" prop="sytangnum" style="margin-bottom: 20px;">
              <el-input type="text" v-model="ruleForm.sytangnum" autocomplete="off"></el-input>
            </el-form-item>
             <el-form-item label="始祖名讳" prop="syancestorname" style="margin-bottom: 20px;">
              <el-input type="text" v-model="ruleForm.syancestorname" autocomplete="off"
                        placeholder="请填写全名"></el-input>
            </el-form-item>
            <el-form-item label="世系" prop="syfamilytree" style="margin-bottom: 20px;">
              <el-input type="number" v-model.number="ruleForm.syfamilytree" autocomplete="off" style="width:100px"
                        :min="0"
                        :step="1"></el-input>&nbsp;&nbsp;世
            </el-form-item>
             <el-form-item label="发源地" prop="sybefrom" style="margin-bottom: 20px;">
              <Area :propsinorout="ruleForm.syfyinorout || 1" :propssheng="ruleForm.syfysheng"
                    :propsshi="ruleForm.syfyshi"
                    :propsxian="ruleForm.syfyxian" :propszhen="ruleForm.syfyzhen" :propsdizhi="ruleForm.syfyzdydz"
                    @area="syareaFun"></Area>
            </el-form-item>
            <el-form-item label="起始年代" prop="syfromyear" style="margin-bottom: 20px;">
              <el-input type="text" v-model="ruleForm.syfromyear" autocomplete="off"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleAddForm')">确定</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-dialog>

    <el-dialog title="手机短信验证码" :visible.sync="moileDialog" width="30%">
      <span>
        <el-input prefix-icon="el-icon-menu" style="width: 54%;" type="text" v-model="phoneCode"
                  autocomplete="off"></el-input>
        <el-button type="primary" @click="getMobileCode()" style="margin-left: 10px">{{ codeMsg }}</el-button>
        <!-- <el-input prefix-icon="el-icon-menu" type="text" v-model="mobcode" autocomplete="off"></el-input> -->

        <el-input prefix-icon="el-icon-menu" style="width: 54%;margin-top:20px" type="text" v-model="oneCode"
                  autocomplete="off"></el-input>
        <img :src="sendmsgscr" alt="" @click="captchaCode('delfamily')" style="vertical-align: top;margin-top:20px"/>
      </span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="delFun()">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="获取验证码" :visible.sync="dialogMobileCodeVisible" width="90%">
      <span>
        <el-input prefix-icon="el-icon-menu" style="width: 54%;margin-top:20px" type="text" v-model="code"
                  autocomplete="off"></el-input>
        <img :src="sendScr" alt="" @click="captchaCode('sendmsg')" style="vertical-align: top;margin-top:20px"/>
      </span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="getPhoneCode()">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="权限设置" :visible.sync="jurisdictionDialog" width="1200px">
      <el-button @click="jurisdictionAddClick()" type="primary" size="small">添加</el-button>

      <table class="jurisdictionTable">
        <thead>
        <tr style="height:40px">
          <th>用户手机</th>
          <th>姓名</th>
          <th>性别</th>
          <th>所在地</th>
          <!-- <th>手机号码</th> -->
          <th>权限</th>
          <th>祖先</th>
          <th>备注</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in jurisdictionTableData" :key="index">
          <td style="width:130px">{{ item.mobile }}</td>
          <td style="width:100px;">{{ item.name }}</td>
          <td style="width:55px;text-align: center;">{{ item.sex == 0 ? "男" : "女" }}</td>
          <td style="width:200px;">{{ item.address }}</td>
          <!-- <td>{{ item.mobile }}</td> -->
          <td style="width:120px;text-align: center;">
            <span v-if="item.level == 0">总管理员</span>
            <span v-if="item.level == 1">分支管理员</span>
            <span v-if="item.level == 2">阅谱员</span>
          </td>
          <td style="width:180px;">
            {{ item.mname }}
            <span v-if="item.shixu"> [{{ item.shixu }}世] 后裔 </span>
          </td>
          <td style="width:200px;">{{ item.remarks }}</td>
          <td style="width:160px">
            <el-button @click="jurisdictionEditClick(item)" type="primary" size="small" style="margin:3px 0 3px 0;">
              编辑
            </el-button>
            <el-button @click="jurisdictionDelClick(item)" type="danger" size="small" style="margin:3px 0 3px 0;">删除
            </el-button>
          </td>
        </tr>
        </tbody>
      </table>
      <!-- <el-table :data="jurisdictionTableData" style="width: 100%">
          <el-table-column prop="mobile" label="用户手机"> </el-table-column>
          <el-table-column prop="" label="姓名"> </el-table-column>
          <el-table-column prop="" label="性别" align="center">
              <template slot-scope="scope">
                  <span v-if="scope.row.sex == 0">男</span>
                  <span v-if="scope.row.sex == 1">女</span>
              </template>
          </el-table-column>
          <el-table-column prop="address" label="所在地"> </el-table-column>
          <el-table-column prop="mobile" label="手机号码"> </el-table-column>
          <el-table-column prop="level" label="权限" align="center">
              <template slot-scope="scope">

              </template>
          </el-table-column>
          <el-table-column prop="mname" label="祖先">
              <template slot-scope="scope">
                  {{ scope.row.mname }}
                  <span v-if="scope.row.shixu"> [{{ scope.row.shixu }}世] 后裔 </span>
              </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">

              </template>
          </el-table-column>
      </el-table> -->
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="jurisdictionDialog = false">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="jurisdictionDialogFamily" width="530px">
      <span>
        <el-form :model="jurisdictionRuleForm" status-icon ref="ruleForm" label-width="120px" label-position="left"
                 class="demo-ruleForm">
          <el-form-item label="ID" prop="id" style="display:none">
            <el-input type="text" v-model="jurisdictionRuleForm.id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input type="text" v-model="jurisdictionRuleForm.mobile" autocomplete="off"
                      style="width: 200px"></el-input>
            <el-button type="primary" @click="searchbymobile()" style="margin-left: 10px">查找</el-button>
          </el-form-item>
          <div class="el-form-item el-form-item--feedback">
            <label class="el-form-item__label" style="width: 120px;">姓名</label>
            <div class="el-form-item__content" style="margin-left: 120px;">{{
                jurisdictionRuleForm.name
              }}</div>
          </div>
          <div class="el-form-item el-form-item--feedback">
            <label class="el-form-item__label" style="width: 120px;">性别</label>
            <div class="el-form-item__content" style="margin-left: 120px;">
              {{ jurisdictionRuleForm.sex == 0 ? "男" : jurisdictionRuleForm.sex == 1 ? "女" : "" }}
            </div>
          </div>
          <div class="el-form-item el-form-item--feedback">
            <label class="el-form-item__label" style="width: 120px;">所在地</label>
            <div class="el-form-item__content" style="margin-left: 120px;">{{
                jurisdictionRuleForm.address
              }}</div>
          </div>
          <el-form-item label="备注" prop="remarks">
            <el-input type="text" v-model="jurisdictionRuleForm.remarks" autocomplete="off"
                      style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="分支祖先" prop="mid" v-if="jurisdictionRuleForm.level == 1">
            <el-input type="text" v-model="jurisdictionRuleForm.xm" @focus="mTree()" autocomplete="off"
                      style="width: 100px"></el-input>
            {{ jurisdictionRuleForm.shixu }}
            <!-- <treeSelect
                          :props="props"
                          :options="list"
                          :value="jurisdictionRuleForm.mid"
                          :clearable="isClearable"
                          :accordion="isAccordion"
                          @getValue="getValue($event)"
                      /> -->
          </el-form-item>
          <el-form-item label="等级" prop="level">
            <!-- <el-input type="text" v-model="jurisdictionRuleForm.level" autocomplete="off"></el-input> -->
            <el-radio v-model="jurisdictionRuleForm.level" :label="0">总管理员</el-radio>
            <el-radio v-model="jurisdictionRuleForm.level" :label="1">分支管理员</el-radio>
            <el-radio v-model="jurisdictionRuleForm.level" :label="2">阅谱员</el-radio>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="jurisdictionSubmitForm()">确定</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogMap" width="500" class="map">
      <vmap @getLnglat="getPosi"></vmap>
    </el-dialog>

    <el-dialog :visible.sync="dialogTree" width="500" class="dialogTree">
      <el-tree :data="list" :props="defaultProps" @node-click="handleNodeClick" :default-expand-all="true"
               :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span> [{{ data.shixu }}世]</span>
          <span :style="{ 'font-size': '14px', color: data.sex == 1 ? '#ffabd5' : '' }" v-html="data.xm"> </span>
          <span>[行{{ data.ph == 0 ? "一" : toChies(data.ph) }} ]</span>
        </span>
      </el-tree>
    </el-dialog>
  </div>
</template>
<script>
import Head from "@/components/header.vue";
import orgtree from "@/components/orgtree.vue";
import vmap from "@/components/vmap.vue";
import treeSelect from "@/components/treeSelect.vue";
import Area from "@/components/area.vue";

import member from "./member.vue";
import api from "@/request/api";

export default {
  data() {
    return {
      showType: false,
      dialogVisible: false,
      dialogMobileCodeVisible: false,
      moileDialog: false,
      dialogFamily: false,
      ruleForm: {
        name: "", //家谱名
        familyname: "", // 家族姓氏
        tangnum: "", // 堂号
        ancestorname: "", // 始祖名讳
        befrom: "", // 发源地
        familytree: "", // 本谱世系
        beforefamilytree: "", // 上游谱中世系
        intro: "", // 家族简介
        fromyear: "",//起始年代
        coordinate: "",
        shang: 0,
        mz: "",
        fydtdz: "",
        fysheng: "",
        fyshi: "",
        fyxian: "",
        fyzhen: "",
        fyzdydz: "",
        sytangnum: "",
        syancestorname: "",
        syfromyear: "",
        syfydtdz: "",
        syfysheng: "",
        syfyshi: "",
        syfyxian: "",
        syfyzdydz: "",
        syfyzhen: "",
        sybefrom: "",
        sycoordinate: "",
        syfamilytree: "",
      },
      type: "",

      tableData: [],
      mobcode: "",
      code: "",//点击获取手机验证码
      oneCode: "",//第一步的图形验证码
      phoneCode: "",
      countdown: 60,
      familyFid: '',//fid
      //按钮上的文字
      codeMsg: "获取验证码",
      mobileCode: "",
      //定时器
      timer: null,
      sendmsgscr: "",
      sendScr: "",
      dialogMap: false,
      maKkey: "",
      jurisdictionDialog: false,
      jurisdictionTableData: [],
      jurisdictionDialogFamily: false,
      jurisdictionFid: "",
      jurisdictionRuleForm: {
        id: "",
        mobile: "",
        mid: "",
        level: ""
      },
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props: {
        // 配置项（必选）
        value: "id",
        label: "xm",
        children: "children"
        // disabled:true
      },
      // 选项列表（必选）
      list: [],
      defaultProps: {
        children: "children",
        label: "xm"
      },
      dialogTree: false,
      familyId: "",
      addRules: {
          name: [
            { required: true, message: '请输入家谱名称', trigger: 'blur' },
          ],
          familyname: [
            { required: true, message: '请输入家族姓氏', trigger: 'blur' },
          ],
          mz: [
            { required: true, message: '请选择民族', trigger: 'change' },
          ],
          /* tangnum: [
            {required: true, message: '请输入堂号', trigger: 'blur' },
          ],
          sytangnum: [
            {required: true, message: '请输入堂号', trigger: 'blur' },
          ], */
          ancestorname: [
            { required: true, message: '请输入始祖名讳', trigger: 'blur' },
          ],
          familytree: [
            { required: true, message: '请选择本谱世系', trigger: 'change' },
          ],
          syfromyear: [
            { required: true, message: '请输入起始年代', trigger: 'blur' },
          ],
          fromyear: [
            { required: true, message: '请输入起始年代', trigger: 'blur' },
          ],
          syfamilytree: [
            { required: true, message: '请选择世系', trigger: 'change' },
          ],
          syancestorname: [
            { required: true, message: '请输入始祖名讳', trigger: 'blur' },
          ],
          beforefamilytree: [
            { required: true, message: '请选择上源谱世系', trigger: 'change' },
          ],
          // befrom: [
          //   { required: true, message: '请选择发源地', trigger: 'change' },
          // ],
        }
    };
  },
  mounted() {
    if (this.isMobile()) {
      // 手机端
      sessionStorage.setItem("flag", "app");
      this.flag = "app";
      this.$router.push("/mobileguide");
    } else {
      // pc端
      sessionStorage.setItem("flag", "pc");
      this.flag = "pc";
    }
    this.getList();
  },
  methods: {
    searchbymobile() {
      if (this.jurisdictionRuleForm.mobile == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      api.selectbymobile(this.jurisdictionRuleForm.mobile).then((res) => {
        if (res.code == 0) {
          this.jurisdictionRuleForm.name = res.data.name;
          this.jurisdictionRuleForm.address = res.data.address;
          this.jurisdictionRuleForm.sex = res.data.sex;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    },
    getList() {
      api.familyList().then((res) => {
        if (res.code == 0) {
          this.tableData = res.data;
          console.log(this.tableData)
          res.data.forEach((index, item) => {
            if (res.data[item].isdefault == 1) {
              localStorage.setItem("fid", res.data[item].id);
            }
          });
          // if(!localStorage.getItem("fid")){
          //     localStorage.setItem("fid", res.data[0].id);
          // }
          //api.setDefaultFamily(res.data[0].id).then((res) => {});
          // api.getDefaultFamily().then((res) => {
          //     if (res.data) {
          //         this.familyId = res.data;
          //     } else {
          //         this.$message({
          //             message: "请先设置家谱!",
          //             type: "warning"
          //         });
          //     }
          // });
        }
      });
    },
    addClick() {
      this.dialogFamily = true;
      this.type = "add";
      this.ruleForm = {
        name: "",//家谱名
        familyname: "", // 家族姓氏
        tangnum: "", // 堂号
        ancestorname: "", // 始祖名讳
        befrom: "", // 发源地
        shang: 0,
        familytree: "", // 本谱世系
        // beforefamilytree: "", // 上游谱中世系
        intro: "", // 家族简介
        fromyear: "",
        coordinate: "",
        mz: "",
        fydtdz: "",
        fysheng: "",
        fyshi: "",
        fyxian: "",
        fyzhen: "",
        fyzdydz: "",
        sytangnum: "",
        syancestorname: "",
        syfromyear: "",
        syfydtdz: "",
        syfysheng: "",
        syfyshi: "",
        syfyxian: "",
        syfyzdydz: "",
        syfyzhen: "",
        sybefrom: "",
        sycoordinate: "",
        syfamilytree: "",
      };
    },
    submitForm() {
      if (this.type == "add") {
        this.$refs['ruleAddForm'].validate((valid) => {
          if (valid) {
            api.familyAdd(this.ruleForm).then((res) => {
              if (res.code == 0) {
                this.getList();
                this.$message({
                  message: "添加成功",
              type: "success"
                });
                this.dialogFamily = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
       
      } else {
        this.$refs['ruleAddForm'].validate((valid) => {
          if (valid) {
            api.familyEdit(this.ruleForm).then((res) => {
              if (res.code == 0) {
                this.getList();
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.dialogFamily = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      }
    },
    mapOpen(key) {
      this.maKkey = key;
      this.dialogMap = true;
    },
    getPosi(lng, lat, address) {
      this.dialogMap = false;
      this.$set(this.ruleForm, this.maKkey, lng + ", " + lat);
    },
    // delClick(row) {
    //   this.moileDialog = true;
    //   this.captcha();
    // },
    candelClick(id) {
      this.jurisdictionFid = id;
      this.jurisdictionDialog = true;
      api.permissionlist({fid: id}).then((res) => {
        if (res.code == 0) {
          this.jurisdictionTableData = res.data;
        }
      });
      api.listtreename({fid: id}).then((res) => {
        this.list = res.data;
      });
    },
    delClick(row) {
      this.familyFid = row.id;
      this.phoneCode = '';
      this.code = '';
      this.oneCode = '';
      this.$confirm("此操作将永久删除该家谱, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log(row.id)
        api.familyDel({
          id: row.id,
        }).then((res) => {
          if (res.code == 0) {

            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
            this.moileDialog = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      });
    },
    //验证码
    captchaCode(type) {
      //type= delfamily   第一图片验证码
      console.log(type, '----type')
      if (type == 'delfamily') {
        api.captcha(type).then((res) => {
          this.sendmsgscr = res.data;
        });
      } else if (type == 'sendmsg') {
        api.captcha('sendmsg').then((res) => {
          this.sendScr = res.data;
        });
      }
    },
    getMobileCode() {
      this.captchaCode('sendmsg')
      !this.timer ? (this.dialogMobileCodeVisible = true) : "";
    },
    //获取短信验证码
    getPhoneCode() {
      if (!this.timer) {
        if (this.code == '') {
          this.$message({
            message: "请输入图形验证码",
            type: "warning"
          });
        } else {
          let dataParams = {
            fid: this.familyFid,
            type: 4,
            code: this.code
          }
          api.sendDelMsg(dataParams).then((res) => {
            if (res.code == 0) {
              this.setTime();
              setTimeout(() => {
                this.$message({
                  message: "发送成功",
                  type: 'success'
                });
                this.dialogMobileCodeVisible = false;
              }, 500)


            } else {
              // this.$message({
              //   message: res.msg,
              //   type: "warning"
              // });
              this.captchaCode('sendmsg');
            }
          });
        }
      }
      // return false
      // api.familyDel({
      //   fid: 1,
      //   mobcode: this.mobcode,
      //   code: this.code
      // }).then((res) => {
      //   if (res.code == 0) {
      //     this.$message({
      //       message: "删除成功"
      //     });
      //     this.moileDialog = false;
      //   } else {
      //     this.$message({
      //       message: res.msg,
      //       type: "warning"
      //     });
      //     this.captcha();
      //   }
      // });
    },
    //倒计时
    setTime() {
      let _this = this;
      this.timer = setInterval(() => {
        if (_this.countdown > 0 && _this.countdown <= 60) {
          _this.countdown--;
          if (_this.countdown !== 0) {
            _this.codeMsg = "重新发送(" + _this.countdown + ")";
          } else {
            clearInterval(_this.timer);
            _this.codeMsg = "获取验证码";
            _this.countdown = 60;
            _this.timer = null;
          }
        }
      }, 1000);
    },
    editClick(row) {
      this.dialogFamily = true;
      this.type = "edit";
      this.ruleForm = {
        name: row.name,
        familyname: row.familyname, // 家族姓氏
        tangnum: row.tangnum, // 堂号
        ancestorname: row.ancestorname, // 始祖名讳
        befrom: row.befrom, // 发源地
        familytree: row.familytree, // 本谱世系
        beforefamilytree: row.beforefamilytree, // 上游谱中世系
        intro: row.intro, // 家族简介
        fromyear: row.fromyear,
        shang:row.shang,
        id: row.id,
        coordinate: row.coordinate,
        mz: row.mz,
        fydtdz: row.fydtdz,
        fysheng: row.fysheng,
        fyshi: row.fyshi,
        fyxian: row.fyxian,
        fyzhen:row.fyzhen,
        fyzdydz: row.fyzdydz,
        sytangnum: row.sytangnum,
        syancestorname: row.syancestorname,
        syfromyear: row.syfromyear,
        syfydtdz: row.syfydtdz,
        syfysheng: row.syfysheng,
        syfyshi: row.syfyshi,
        syfyxian: row.syfyxian,
        syfyzdydz: row.syfyzdydz,
        syfyzhen: row.syfyzhen,
        sybefrom: row.sybefrom,
        sycoordinate: row.sycoordinate,
        syfamilytree: row.syfamilytree,
      };
      console.log(this.ruleForm)
    },
    viewClick(row) {
      api.familyGet(row.id).then((res) => {
        api.setDefaultFamily(res.data.id).then((res) => {
        });
        // this.$store.dispatch("getActionsData", { key: "fid", val: res.data.id });
        // this.$store.dispatch("getActionsData", { key: "fid", val: res.data.id });
        localStorage.setItem("fid", res.data.id);
        this.$router.push("/lineageChart");
      });
    },
    jurisdictionAddClick() {
      this.jurisdictionType = "add";
      this.jurisdictionDialogFamily = true;
      this.jurisdictionRuleForm = {
        id: "",
        mobile: "",
        mid: "",
        xm: "",
        name: "",
        address: "",
        shixu: "",
        remarks: "",
        level: 0
      };
    },
    jurisdictionEditClick(row) {
      this.jurisdictionType = "edit";
      this.jurisdictionDialogFamily = true;
      this.jurisdictionRuleForm = {
        id: row.id,
        mobile: row.mobile,
        xm: row.mname,
        mid: row.mid,
        sex: row.sex,
        address: row.address,
        name: row.name,
        shixu: row.shixu ? "[" + row.shixu + "世后裔]" : "",
        remarks: row.remarks,
        level: row.level
      };
    },
    jurisdictionDelClick(row) {
      this.$confirm("此操作将永久删除该权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          api.permissiondel({id: row.id}).then((res) => {
            if (res.code == 0) {
              this.candelClick(this.jurisdictionFid);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getValue(value) {
      // this.valueId = value;
      this.jurisdictionRuleForm.mid = value;
    },
    jurisdictionSubmitForm() {
      if (this.jurisdictionType == "add") {
        this.jurisdictionRuleForm.fid = this.jurisdictionFid;
        api.permissionadd(this.jurisdictionRuleForm).then((res) => {
          if (res.code == 0) {
            this.candelClick(this.jurisdictionFid);
            this.$message({
              message: "添加成功"
            });
            this.jurisdictionDialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      } else {
        api.permissionupdate(this.jurisdictionRuleForm).then((res) => {
          if (res.code == 0) {
            this.candelClick(this.jurisdictionFid);
            this.$message({
              message: "修改成功"
            });
            this.jurisdictionDialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      }
    },
    areaFun(data) {
      // if (data.keyType == "spouseList") {
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "inorout", data.inorout);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "sheng", data.sheng);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "shi", data.shi);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "xian", data.xian);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zhen", data.zhen);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zdydz", data.dizhi);
      //     // this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "dtdz", data.dtdz);
      // } else {
      this.$set(this.ruleForm, "fyinorout", data.inorout);
      this.$set(this.ruleForm, "fysheng", data.sheng);
      this.$set(this.ruleForm, "fyshi", data.shi);
      this.$set(this.ruleForm, "fyxian", data.xian);
      this.$set(this.ruleForm, "fyzhen", data.zhen);
      this.$set(this.ruleForm, "fyzdydz", data.dizhi);
      this.$set(this.ruleForm, "fydtdz", data.dtdz);
      // }
    },
    syareaFun(data) {
      // if (data.keyType == "spouseList") {
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "inorout", data.inorout);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "sheng", data.sheng);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "shi", data.shi);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "xian", data.xian);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zhen", data.zhen);
      //     this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zdydz", data.dizhi);
      //     // this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "dtdz", data.dtdz);
      // } else {
      this.$set(this.ruleForm, "syfyinorout", data.inorout);
      this.$set(this.ruleForm, "syfysheng", data.sheng);
      this.$set(this.ruleForm, "syfyshi", data.shi);
      this.$set(this.ruleForm, "syfyxian", data.xian);
      this.$set(this.ruleForm, "syfyzhen", data.zhen);
      this.$set(this.ruleForm, "syfyzdydz", data.dizhi);
      this.$set(this.ruleForm, "syfydtdz", data.dtdz);
      // }
    },
    mTree() {
      this.dialogTree = true;
    },
    handleNodeClick(data) {
      this.dialogTree = false;
      this.jurisdictionRuleForm.mid = data.id;
      this.jurisdictionRuleForm.xm = data.xm;
      this.jurisdictionRuleForm.shixu = data.shixu ? data.shixu + "世后裔" : "";
    }
  },
  computed: {
    /* 转树形数据 */
    optionData() {
      // let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
      let cloneData = JSON.parse(
        JSON.stringify([
          {id: 1, parentId: 0, name: "一级菜单A", rank: 1},
          {id: 2, parentId: 0, name: "一级菜单B", rank: 1},
          {id: 3, parentId: 0, name: "一级菜单C", rank: 1},
          {id: 4, parentId: 1, name: "二级菜单A-A", rank: 2},
          {id: 5, parentId: 1, name: "二级菜单A-B", rank: 2},
          {id: 6, parentId: 2, name: "二级菜单B-A", rank: 2},
          {id: 7, parentId: 4, name: "三级菜单A-A-A", rank: 3},
          {id: 8, parentId: 7, name: "四级菜单A-A-A-A", rank: 4},
          {id: 9, parentId: 0, name: "一级菜单C", rank: 1},
          {id: 10, parentId: 0, name: "一级菜单end", rank: 1}
        ])
      );
      var data = cloneData.filter((father) => {
        // 循环所有项，并添加children属性
        let branchArr = cloneData.filter((child) => father.id == child.parentId); // 返回每一项的子级数组
        branchArr.length > 0 ? (father.children = branchArr) : ""; //给父级添加一个children属性，并赋值
        return father.parentId == 0; //返回第一层
      });
      return data;
    },
    toChies(val) {
      return function (val) {
        console.log(val);
        return this.$utils.toChies(val);
      };
    }
  },
  components: {
    Head,
    orgtree,
    vmap,
    member,
    treeSelect,
    Area
  }
};
</script>

<style lang="less" scoped>

.family {
  overflow: hidden;
  height: 100%;

  .chartTop {
    height: 55px;
    line-height: 55px;

    h1 {
      width: 350px;
      font-size: 20px;
    }
  }

  .listDiv {
    overflow: auto;
    // height: 100%;
    height: calc(100vh - 185px);

    > ul {
      width: 810px;
      margin: 0 auto;
      font-size: 16px;
      line-height: 20px;

      li {
        margin-bottom: 30px;
        border-bottom: 1px solid #000;

        > div {
          border: 1px solid #000;
          border-left: 2px solid #000;
          border-right: 2px solid #000;
          border-bottom: 0;

          // div {
          //   width: 80px;
          //   height: 30px;
          //   padding: 20px 7px 0;
          //   margin-right: 0px;
          //   text-align: justify;
          //   display: inline-block;
          //   font-size: 15px;
          //   b {
          //     display: inline-block;
          //     padding-left: 100%;
          //   }
          // }
          .tableT {
            width: 810px;
            border-collapse: collapse;
            /* 边框合并 */

            tr {
              width: 100%;
              height: 30px;

              td {
                padding: 20px 7px;
                text-align: center;

                span {
                  color: #606266;
                  text-align: center;
                  font-size: 15px;
                  font-family: "楷体", "KaiTi", "STKaiti", serif;
                  font-weight: bold;

                }
              }

              .label {
                width: 90px;
                margin-right: 0px;
                // text-align: justify;
                font-size: 15px;
                text-align: center;
              }
            }

          }


          span {
            width: 713px;
            color: #000;
            text-align: center;
            font-size: 15px;
          }

          .intro {
            text-align: left;
            text-indent: 32px;
            white-space: pre-wrap;
          }

          > * {
            // display: inline-block;
            padding: 20px;
            box-sizing: border-box;
            vertical-align: top;
          }
        }
      }
    }
  }
}

.dialogTree {
  overflow: auto;
}

.jurisdictionTable {
  margin-top: 10px;
  width: 100%;

  th {
    text-align: center;
  }

  th,
  td {
    padding: 0px 10px;
    border: 1px solid #000;
  }

  border: 1px solid #000;
}

:deep(.custom-input .el-input__inner) {
  font-size: 18px;
  /* 调大字号 */
  color: #000;
  /* 强制黑色 */
  font-weight: 500;
  /* 中等字重 */
}

/* 仅修改当前输入框的禁用状态 */
:deep(.custom-input.is-disabled .el-input__inner) {
  background-color: #f5f7fa;
  color: #000;
}

/* 保持其他输入框默认样式 */
.el-input:not(.custom-input) .el-input__inner {
  /* 默认样式 */
}
</style>



// WEBPACK FOOTER //
// src/views/family.vue